export default __webpack_public_path__ + "static/media/bar_chart_2.2ae2f1c7.svg";